<template>
  <div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide banner-sw" v-for="(banner,index) in bannerList" :key="index">
          <a :href="banner.bannerUrl">
            <img :src="banner.bannerLink" alt />
          </a>
          <!-- <img v-lazy="banner.bannerLink" alt=""> -->
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import CONSTANT from "@/constant/constant.js";
import common from "@/common.js";
export default {
  name: "Banner",
  props: ["banners"],
  data() {
    return {
      // swiper 轮播图的实例对象
      mySwiper: null,
      bannerList: [],
    };
  },
  methods: {
    initSeiper() {
      this.mySwiper = new Swiper(".swiper-container", {
        loop: true, // 循环模式选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true,
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
    // 获取首页数据
    getList() {
      this.banners.forEach((ele) => {
        if (ele.enable) {
          this.bannerList.push(ele);
        }
      });
      this.$nextTick(() => {
        this.initSeiper();
      });
    },
  },
  created() {
    this.getList();
    this.initSeiper();
  },
};
</script>

<style lang="less" scope>
.banner-sw {
  width: 100%;
  height: 100%;
  a {
    display: block;
    height: 100%;
    width: 100%;
    img {
      height: 100%;
      width: 100%;
    }
  }
}
.swiper-container {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.swiper-container-horizontal {
  .swiper-pagination-bullets {
    bottom: 40px;
    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      border: 1px solid rgba(0, 0, 0, 1);
      opacity: 0.8;
      border-radius: 50%;
      background: #fff;
    }
    .swiper-pagination-bullet-active {
      position: relative;
      width: 15px;
      height: 15px;
      border: 1px solid rgba(90, 50, 40, 1);
      opacity: 0.8;
      border-radius: 50%;
      margin-bottom: -4px;
      &::after {
        position: absolute;
        width: 5px;
        height: 5px;
        content: "";
        left: 50%;
        top: 50%;
        border-radius: 50%;
        margin-left: -2.5px;
        margin-top: -2.5px;
        background: #000;
      }
    }
  }
}
</style>
